import { action, observable } from 'mobx';

import customFetch from '../../../utils/customFetch';

class JobTitleStore {
  @observable loading = false;
  @observable loadingAcc = true;
  @observable dataAcc = null;

  @observable activeIdx = 0;
  @observable type = null;

  @observable dataJobTitle = {
    id: 0,
    name: '',
    descriptions: '',
    isActive: false,
  };
  @observable dataClaim = {
    id: 0,
    name: '',
    descriptions: '',
    isActive: false,
  };
  @observable dataReport = {
    id: 0,
    name: '',
    descriptions: '',
    isActive: false,
    periodDays: 0,
    qualifiedAccreditations: [],
  };

  @observable open = false;
  @observable modalParams = {};

  @action setFieldsValue = obj => {
    Object.keys(obj).forEach(key => {
      this[key] = obj[key];
    });
  };

  @action fetchDetail = () => {
    this.loadingAcc = true;
    customFetch('/TypesOfReport/GetSpecificLookupConfigByType', {
      method: 'POST',
      headers: { 'Content-type': 'application/json' },
      body: JSON.stringify({
        type: 'acc',
      }),
    }).then(
      action(data => {
        this.dataAcc = data;
        this.loadingAcc = false;
      }),
    );
  };

  @action onAddNew = type => {
    if (type === 'jobTitle') {
      this.dataJobTitle = {
        id: 0,
        name: '',
        descriptions: '',
        isActive: false,
      };
      this.activeIdx = 0;
    }
    if (type === 'typeOfClaim') {
      this.dataClaim = {
        id: 0,
        name: '',
        descriptions: '',
        isActive: false,
      };
      this.activeIdx = 1;
    }
    if (type === 'typeOfReport') {
      this.dataReport = {
        id: 0,
        name: '',
        descriptions: '',
        isActive: false,
        periodDays: 0,
        qualifiedAccreditations: 0,
      };
      this.activeIdx = 2;
    }
  };
  toggleModal = (isOpen, params = {}) => {
    return action(() => {
      this.open = isOpen;
      this.modalParams = params;
    });
  };

  @action onReset = () => {
    this.dataJobTitle = {
      id: 0,
      name: '',
      descriptions: '',
      isActive: false,
    };
  };
}

export default new JobTitleStore();
